import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseModal from 'components/atoms/base-modal';
import BaseButton from 'components/atoms/baseButton';

import s from './styles.module.scss';

export interface IScheduledMessageModalProps {
  isOpen: boolean;
  toggle: () => void;
  sendNow: () => void;
  sendLater: () => void;
  sendLaterLoading: boolean;
}

const ScheduledMessageModal: React.FC<IScheduledMessageModalProps> = (
  props,
) => {
  const { isOpen, toggle, sendNow, sendLater, sendLaterLoading } = props;
  const { t } = useTranslation();

  const toggleModal = () => {
    toggle();
  };

  return (
    <BaseModal
      title={t('smsDashboard.schedule_message')}
      open={isOpen}
      onCancel={toggleModal}
      bodyClassNames={s['modal-body']}
      width={552}
      withFooter={[
        <BaseButton
          dataCy="contactAvailability-cancel-button"
          key="cancel"
          type="secondary"
          label={t('controls.sendNow')}
          onClick={sendNow}
          className={s['send-now-button']}
        />,
        <BaseButton
          dataCy="contactAvailability-save-button"
          key="save"
          type="primary"
          label={t('controls.sendLater')}
          loading={sendLaterLoading}
          onClick={sendLater}
          className={s['send-later-button']}
        />,
      ]}
    >
      <div className={s.title}>
        <p>{t('smsDashboard.contact_availability_not_available_message')}</p>
      </div>
      <div className={s.description}>
        <p>{t('smsDashboard.send_now_or_at_next_available_time')}</p>
      </div>
    </BaseModal>
  );
};

export default ScheduledMessageModal;
